import React from 'react';
import { Bar } from 'react-chartjs-2';

const COLORS = ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16', '#F97316', '#6366F1'];

const TopTailors = ({ data }) => {
    if (!data || data.length === 0) return null;

    const maxShow = Math.min(data.length, 8);
    const sliced = data.slice(0, maxShow);
    const labels = sliced.map(d => d.employee_name?.split(' ').slice(0, 2).join(' ') || 'Unknown');
    const values = sliced.map(d => d.total_pieces);
    const colors = labels.map((_, i) => COLORS[i % COLORS.length]);

    const chartData = {
        labels,
        datasets: [{
            label: 'Pieces',
            data: values,
            backgroundColor: colors,
            borderRadius: 4,
        }],
    };

    const options = {
        responsive: true,
        indexAxis: 'y',
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: { title: { display: true, text: 'Pieces Produced' } },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Top Tailors by Output</h6>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

const DailyProduction = ({ data }) => {
    if (!data || data.length === 0) return null;

    const maxShow = Math.min(data.length, 20);
    const sliced = data.slice(0, maxShow);
    const labels = sliced.map(d => {
        const date = new Date(d.date + 'T00:00:00');
        return date.getDate().toString();
    });
    const values = sliced.map(d => d.pieces);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Pieces',
                data: values,
                backgroundColor: 'rgba(59,130,246,0.7)',
                borderRadius: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
        },
        scales: {
            x: { title: { display: true, text: 'Day of Month' } },
            y: { title: { display: true, text: 'Pieces' } },
        },
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Daily Production</h6>
                <div className="mb-2">
                    <span className="text-muted me-3" style={{ fontSize: '0.8rem' }}>
                        Total: <strong>{data.reduce((s, d) => s + d.pieces, 0).toLocaleString()}</strong>
                    </span>
                    <span className="text-muted" style={{ fontSize: '0.8rem' }}>
                        Value: <strong>{data.reduce((s, d) => s + d.value, 0).toLocaleString(undefined, { minimumFractionDigits: 3 })} KWD</strong>
                    </span>
                </div>
                <Bar data={chartData} options={options} />
            </div>
        </div>
    );
};

const ProductionCharts = ({ topTailors, dailyProduction }) => {
    if (!topTailors && !dailyProduction) return null;

    return (
        <div className="mb-4">
            <h5 className="mb-3 border-bottom pb-2">Production & Tailor Productivity</h5>
            <div className="row g-3">
                <div className="col-md-6">
                    <TopTailors data={topTailors} />
                </div>
                <div className="col-md-6">
                    <DailyProduction data={dailyProduction} />
                </div>
            </div>
        </div>
    );
};

export default ProductionCharts;
